/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CalculatorIcon64Regular = forwardRef('CalculatorIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M21 20a1.5 1.5 0 0 0 0 3h22a1.5 1.5 0 0 0 0-3H21Z" }),
        React.createElement("path", { d: "M24 34a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }),
        React.createElement("path", { d: "M22 45a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" }),
        React.createElement("path", { d: "M34 34a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }),
        React.createElement("path", { d: "M32 45a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" }),
        React.createElement("path", { d: "M44 34a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" }),
        React.createElement("path", { d: "M42 45a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.5 6C15.701 6 11 10.701 11 16.5v31C11 53.299 15.701 58 21.5 58h21C48.299 58 53 53.299 53 47.5v-31C53 10.701 48.299 6 42.5 6h-21ZM14 16.5A7.5 7.5 0 0 1 21.5 9h21a7.5 7.5 0 0 1 7.5 7.5v31a7.5 7.5 0 0 1-7.5 7.5h-21a7.5 7.5 0 0 1-7.5-7.5v-31Z" })));
});
